<template>
  <div class="d-flex justify-content-between">
    <v-flex xs12 sm12 md3 lg3 xl3 class="p-2">
      <v-select
          style="border-radius: 8px"
          dense label="تعداد نمایش"
          :items="[10, 25, 50, 100, 500,600,700,800,1000]"
          v-model="value.length"
          :menu-props="{offsetY: true}" outlined/>
    </v-flex>

    <v-flex xs12 sm12 md3 lg3 xl3 class="p-2">
      <slot name="others"></slot>
    </v-flex>

    <v-flex xs12 sm12 md3 lg3 xl3 class="p-2">
      <v-text-field
          flat
          clearable
          outlined dense
          @click:append="getData"
          @click:clear="clearData"
          @keypress.enter="getData"
          v-model="value.search"
          style="border-radius: 8px"
          clear-icon="mdi-close-circle-outline"
          label="جست و جو" append-icon="mdi-magnify"
      />
    </v-flex>
  </div>
</template>

<script>
export default {
  name: "filtersTable",
  props: {
    value: Object
  },
  data() {
    return {
      sendData: false
    }
  },
  watch: {
    value: {
      handler(val) {
        this.$emit('input', val)
      },
      deep: true
    }
  },
  methods: {
    getData() {
      this.sendData = true;
      this.$emit('getInfo', this.sendData);
    },
    clearData() {
      this.sendData = true;
      this.value.search = '';
      this.$emit('getInfo', this.sendData);
    }
  },
}
</script>

<style scoped>

</style>